// extracted by css-extract-rspack-plugin
export default {"TagContainer":"TagEditorParam-module__TagContainer___EUakC","TagName":"TagEditorParam-module__TagName___wYYGj"};